module.exports = "https://cdn.dove.it/_next/static/public/assets/hero/evaluation.ac6575c9ae2de94b07501cfe0519ec9f.jpg";